module.exports = __webpack_public_path__ + "static/media/asx_one.5e12fa3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/asx_one.png
// module id = 105
// module chunks = 0